// Clickini's - before/after slider. A real <input type="range"> sits on top, so it is keyboard and screen-reader accessible.
// <ck-compare-set> switches between several pairs with thumbnail tabs.
(function () {
  if (!window.customElements.get('ck-compare')) {
    class CkCompare extends HTMLElement {
      connectedCallback() {
        var range = this.querySelector('.ck-compare__range');
        if (!range) return;
        var self = this;
        var set = function () { self.style.setProperty('--pos', range.value + '%'); };
        range.addEventListener('input', set);
        set();
      }
    }
    window.customElements.define('ck-compare', CkCompare);
  }
  if (!window.customElements.get('ck-compare-set')) {
    class CkCompareSet extends HTMLElement {
      connectedCallback() {
        var self = this;
        var tabs = this.querySelectorAll('.ck-effect__tab');
        tabs.forEach(function (tab) {
          tab.addEventListener('click', function () {
            self.querySelectorAll('ck-compare').forEach(function (p) { p.hidden = p.id !== tab.dataset.target; });
            tabs.forEach(function (t) { t.setAttribute('aria-selected', t === tab ? 'true' : 'false'); });
          });
        });
      }
    }
    window.customElements.define('ck-compare-set', CkCompareSet);
  }
})();
